const initialState = {
  // Getting Company List
  isGettingCompanyList: false,
  companiesList: [],

  // is Adding Company
  isAddingCompanyList: false,

  // is Updating Company
  isUpdatingCompanyList: false,

  // is Deleting Company
  isDeletingCompanyList: false,

  // Is Getting Province List
  isGettingProvinceList: false,
  provinceList: [],

  // Is Getting Integration Status List
  isGettingIntegrationStatusList: false,
  integrationStatusList: [],

  // Is Changing Company Integration Status
  isChangingCompanyIntegrationStatus: false,

  // Is Uploading Document for logo
  isUploadingDocument: false,

  // Is Getting Company Details
  isGettingCompanyDetails: false,
  companyDetailsList: {},
};

const CompanyListReducer = (state = initialState, action) => {
  switch (action.type) {
    // Getting Client List
    case "COMPANY_LIST_REQUEST":
      return {
        ...state,
        isGettingCompanyList: true,
      };
    case "COMPANY_LIST_SUCCESS":
      return {
        ...state,
        companiesList: action.payload?.data,
        page: action.payload?.page,
        totalResults: action.payload?.totalResults,
        isGettingCompanyList: false,
      };
    case "COMPANY_LIST_ERROR":
      return {
        ...state,
        isGettingCompanyList: false,
      };
    // Editing Client List
    case "ADD_COMPANY_REQUEST":
      return {
        ...state,
        isAddingCompanyList: true,
      };
    case "ADD_COMPANY_SUCCESS":
      return {
        ...state,
        isAddingCompanyList: false,
      };
    case "ADD_COMPANY_ERROR":
      return {
        ...state,
        isAddingCompanyList: false,
      };
    // Updateing HS Client List
    case "UPDATE_COMPANY_LIST_REQUEST":
      return {
        ...state,
        isUpdatingCompanyList: true,
      };
    case "UPDATE_COMPANY_LIST_SUCCESS":
      return {
        ...state,
        isUpdatingCompanyList: false,
      };
    case "UPDATE_COMPANY_LIST_ERROR":
      return {
        ...state,
        isUpdatingCompanyList: false,
      };
    // Deleting HS Client List
    case "DELETE_COMPANY_LIST_REQUEST":
      return {
        ...state,
        isDeletingCompanyList: true,
      };
    case "DELETE_COMPANY_LIST_SUCCESS":
      return {
        ...state,
        isDeletingCompanyList: false,
      };
    case "DELETE_COMPANY_LIST_ERROR":
      return {
        ...state,
        isDeletingCompanyList: false,
      };
    // Get Provice List
    case "PROVINCE_LIST_REQUEST":
      return {
        ...state,
        isGettingProvinceList: true,
      };
    case "PROVINCE_LIST_SUCCESS":
      return {
        ...state,
        isGettingProvinceList: false,
        provinceList: action.payload?.data,
      };
    case "PROVINCE_LIST_ERROR":
      return {
        ...state,
        isGettingProvinceList: false,
      };
    // Getting Integration Status List
    case "INTEGRATION_STATUS_REQUEST":
      return {
        ...state,
        isGettingIntegrationStatusList: true,
      };
    case "INTEGRATION_STATUS_SUCCESS":
      return {
        ...state,
        isGettingIntegrationStatusList: false,
        integrationStatusList: action.payload?.data || [],
      };
    case "INTEGRATION_STATUS_ERROR":
      return {
        ...state,
        isGettingIntegrationStatusList: false,
      };
    // Is Changing Company Integration Status
    case "UPDATE_COMPANY_INTEGRATION_STATUS_REQUEST":
      return {
        ...state,
        isChangingCompanyIntegrationStatus: true,
      };
    case "UPDATE_COMPANY_INTEGRATION_STATUS_SUCCESS":
      return {
        ...state,
        isChangingCompanyIntegrationStatus: false,
      };
    case "UPDATE_COMPANY_INTEGRATION_STATUS_ERROR":
      return {
        ...state,
        isChangingCompanyIntegrationStatus: false,
      };
    // Is Uploading Document of Logo
    case "REQUEST_UPLOAD_DOCUMENT":
      return {
        ...state,
        isUploadingDocument: true,
      };
    case "SUCCESS_UPLOAD_DOCUMENT":
      return {
        ...state,
        isUploadingDocument: false,
      };
    case "ERROR_UPLOAD_DOCUMENT":
      return {
        ...state,
        isUploadingDocument: false,
      };
    // IS Getting CompanyDetails
    case "GET_COMPANY_DETAILS_REQUEST":
      return {
        ...state,
        isGettingCompanyDetails: true,
      };
    case "GET_COMPANY_DETAILS_SUCCESS":
      return {
        ...state,
        isGettingCompanyDetails: false,
        companyDetailsList: action.payload?.data,
      };
    case "GET_COMPANY_DETAILS_ERROR":
      return {
        ...state,
        isGettingCompanyDetails: false,
      };
    default:
      return state;
  }
};

export default CompanyListReducer;
